import { render } from "./ObjectPlannerPositionDefinitionListWidget.vue?vue&type=template&id=79810c96&ts=true"
import script from "./ObjectPlannerPositionDefinitionListWidget.ts?vue&type=script&lang=ts&external"
export * from "./ObjectPlannerPositionDefinitionListWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__